<div class="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
  <div class="relative w-full max-w-md bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 p-6 md:p-8 animate-fade-in-up">

    <div *ngIf="isSaving()" class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="flex items-center justify-between mb-6 pb-4 border-b border-slate-100 dark:border-slate-800">
      <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">lock_reset</span>
        เปลี่ยนรหัสผ่าน
      </h3>
      <button type="button" (click)="onClose()"
        class="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-600 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors border-none bg-transparent cursor-pointer">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="space-y-4">
      <p class="text-[11px] text-slate-400">ต้องกรอกรหัสผ่านเดิมก่อนตั้งรหัสใหม่</p>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">รหัสผ่านเดิม</label>
        <div class="relative">
          <input [type]="showCurrentPassword ? 'text' : 'password'" [(ngModel)]="currentPassword"
            name="currentPassword" autocomplete="current-password" placeholder="รหัสผ่านเดิม"
            class="w-full h-[46px] px-4 pr-12 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
          <button type="button" (click)="showCurrentPassword = !showCurrentPassword"
            class="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-slate-600 border-none bg-transparent cursor-pointer">
            <span class="material-icons text-[20px]">{{ showCurrentPassword ? 'visibility_off' : 'visibility' }}</span>
          </button>
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">รหัสผ่านใหม่</label>
        <div class="relative">
          <input [type]="showNewPassword ? 'text' : 'password'" [(ngModel)]="newPassword"
            name="newPassword" autocomplete="new-password" placeholder="รหัสผ่านใหม่"
            class="w-full h-[46px] px-4 pr-12 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
          <button type="button" (click)="showNewPassword = !showNewPassword"
            class="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-slate-600 border-none bg-transparent cursor-pointer">
            <span class="material-icons text-[20px]">{{ showNewPassword ? 'visibility_off' : 'visibility' }}</span>
          </button>
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ยืนยันรหัสผ่านใหม่</label>
        <div class="relative">
          <input [type]="showConfirmPassword ? 'text' : 'password'" [(ngModel)]="confirmPassword"
            name="confirmPassword" autocomplete="new-password" placeholder="ยืนยันรหัสผ่านใหม่"
            class="w-full h-[46px] px-4 pr-12 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
          <button type="button" (click)="showConfirmPassword = !showConfirmPassword"
            class="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-slate-600 border-none bg-transparent cursor-pointer">
            <span class="material-icons text-[20px]">{{ showConfirmPassword ? 'visibility_off' : 'visibility' }}</span>
          </button>
        </div>
      </div>
    </div>

    <div class="flex items-center justify-end gap-3 mt-8 pt-4 border-t border-slate-100 dark:border-slate-800">
      <button type="button" (click)="onClose()"
        class="px-5 py-2.5 bg-slate-50 dark:bg-slate-800 hover:bg-slate-100 text-slate-500 dark:text-slate-400 font-bold rounded-xl shadow-sm transition-all active:scale-95 cursor-pointer border-none">
        ยกเลิก
      </button>
      <button type="button" (click)="onSave()"
        class="px-6 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-lg hover:shadow-amber-400/20 hover:-translate-y-0.5 transition-all active:scale-95 cursor-pointer border-none">
        เปลี่ยนรหัสผ่าน
      </button>
    </div>
  </div>
</div>
